import type { useNavigate } from '@tanstack/react-router';

/**
 * Route a `Notification.href` value via TanStack Router for in-app
 * paths, fall back to a new-tab `window.open` for external schemes
 * (https / mailto / slack / …) and protocol-relative URLs.
 *
 * The `Notification.href` field is an arbitrary string by schema — a
 * connector emitting a Slack deep-link, a Stripe invoice URL, or a
 * `/insights/abc` in-app path can all show up here. Passing an external
 * URL directly to TanStack Router treats it as a router path and
 * silently breaks the click-through, so both the topbar bell and the
 * `/notifications` inbox call into this helper.
 */
export function navigateToHref(navigate: ReturnType<typeof useNavigate>, href: string): void {
  // `^[a-z]+:` matches scheme prefixes (`https:`, `mailto:`, `slack:`).
  // If absent, treat as in-app path. Protocol-relative `//host/…` also
  // counts as external.
  if (/^[a-z]+:/i.test(href) || href.startsWith('//')) {
    window.open(href, '_blank', 'noopener,noreferrer');
    return;
  }
  navigate({ to: href });
}
